<template>
  <div v-if="isNotMobile" class="func-search-gallery-qr">
    <h4 class="sdpage_QRtext">
      <p v-if="forProceedPrint">
        <LabelFunMessage fcontId="0" msgkey="181" />
      </p>
      <LabelFunMessage v-else fcontId="0" msgkey="25" />
    </h4>
    <p><img :src="app_root + '/assets/article' + fcontId + '/images/qr_pc2sd.png'" class="img-responsive sdpage_QR"></p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from './LabelFunMessage'
export default {
  name: 'FuncSearchGalleryQR',
  components: {
    LabelFunMessage
  },
  props: {
    fcontId: String,
    forProceedPrint: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["setupnavi"]),
    isNotMobile: function() {
      return !(this.$store.state.os == 'ios' || this.$store.state.os == 'ard') 
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.func-search-gallery-qr {
  margin-top: 30px;
}
</style>
